<template>
  <section>
    <v-dialog
      max-width="1110px"
      v-model="createEvent"
    >
      <create-modify-event @close="createEvent = false" @eventCreated="handleEventCreated" :value="editableEvent"/>
    </v-dialog>
    <v-dialog
      max-width="1110px"
      v-model="viewEvent"
    >
      <v-card tile class="pb-5 clearfix">
        <v-sheet
          height="calc(90vh - 70px)"
          class="overflow-y-auto mb-3"
        >
          <v-sheet
            tile
            width="80%"
            class="mx-auto pt-5 pb-10"
          >
            <display-event-info :value="clickedEvent" @close="viewEvent = false"/>
          </v-sheet>
        </v-sheet>
        <v-btn
          text
          class="ml-4"
          @click="viewEvent = false"
        >
          Close
        </v-btn>
        <v-btn
          tile
          class="float-right mr-4"
          color="primary"
          @click="$router.push({ name: 'ViewEvent', params: { id: clickedEvent.id } })"
        >
          View Event Page
        </v-btn>
        <v-btn
          tile
          color="secondary"
          class="float-right mr-4"
          @click="editEvent(clickedEvent)"
          v-if="writePermission"
        >
          <v-icon small class="mr-1">
            mdi-lead-pencil
          </v-icon>
          Edit
        </v-btn>
      </v-card>
    </v-dialog>

    <v-container
      v-resize="onResize"
      id="event-card-list-container">
      <div class="event-list-title">
        <v-row class="mx-auto" :style="`width: ${ $vuetify.breakpoint.mdAndUp ? '400px' : '272px'}`">
          <v-btn
            icon
            class="event-list-button"
            :disabled="!hasPrev"
            @click="changePage(-1)"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <div :style="`width: ${ $vuetify.breakpoint.mdAndUp ? '300px' : '200px'}`"></div>
          <v-btn
            icon
            class="event-list-button"
            :disabled="!hasNext"
            @click="changePage(1)"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </div>
      <v-sheet
        class="mx-auto"
        :width="width"
      >
        <v-sheet
          class="d-flex flex-wrap"
          color="grey lighten-2"
          :height="height"
          :min-height="275"
        >
          <div
            v-if="!selectedEvents || selectedEvents.length === 0"
            class="mx-auto my-auto">
            <h3 class="text-center">No Upcoming Events</h3>
          </div>
          <div
            style="width: 220px; height: 275px"
            v-for="event in selectedEvents"
            :key="event.id"
            @click="showEvent(event)"
          >
            <event-card :event="event"/>
          </div>
        </v-sheet>
        <v-btn
          v-if="writePermission"
          @click="editEvent()"
          class="ml-auto mt-2 float-right"
          color="secondary"
          tile
        >
          <v-icon small class="mr-1">
            mdi-plus
          </v-icon>
          Event
        </v-btn>
      </v-sheet>
    </v-container>
  </section>
</template>

<script>
import {mapGetters} from 'vuex'
import eventCard from './eventCard'
import createModifyEvent from '../modules/createModifyEvents/index.vue'
import DisplayEventInfo from '../modules/viewEvent/components/DisplayEventInfo'


export default {
  name: 'eventCardList',
  components: {
    eventCard,
    createModifyEvent,
    DisplayEventInfo
  },
  props: {
    events: {
      type: [Object, Array],
      require: true,
    }
  },
  data() {
    return {
      selectedEvents: [],
      sortedEvents: [],
      page: 0,
      width: '100%',
      createEvent: false,
      viewEvent: false,
      clickedEvent: undefined,
      editableEvent: undefined
    }
  },
  watch: {
    events: {
      deep: true,
      handler(newValue) {
        this.sortEvents();
        if (this.clickedEvent) {
          const id = this.clickedEvent.id;
          this.clickedEvent = Object.values(newValue).find(event => event.id === id);
        }
      }
    },
    page(newValue) {
      if (newValue < 0) {
        this.page = 0;
        return;
      }

      if (newValue > this.sortedEvents.length % 6) {
        this.page = this.sortedEvents.length % 6;
        return;
      }

      this.getEventsOnPage();
    }
  },
  computed: {
    ...mapGetters('user', ['getUserProfile']),
    hasNext() {
      if (!this.sortedEvents || this.sortedEvents.length <= 6)
        return false;

      return this.sortedEvents.length % 6 > this.page;
    },
    hasPrev() {
      if (!this.sortedEvents || this.sortedEvents.length <= 6)
        return false;

      return this.page > 0;
    },
    height() {
      if (this.width >= 660) {
        if (this.sortedEvents.length > 3)
          return '550px';
        else
          return '275px'
      }

      if (this.width >= 440) {
        if (this.sortedEvents.length <= 2)
          return '275px';
        else if (this.sortedEvents.length <= 4)
          return '550px';
        else
          return '825px';
      }

      return 'auto'

    },
    writePermission() {
      const profile = this.getUserProfile;
      return !!(profile && (profile.siteAdmin || profile.eventAdmin))
    }
  },
  methods: {
    async editEvent(event) {
      if (!event)
        this.editableEvent = undefined;
      else
        this.editableEvent = event;

      this.createEvent = true;
      this.viewEvent = false;
    },
    async showEvent(event) {
      this.clickedEvent = event;
      this.viewEvent = true;
    },
    async changePage(direction) {
      if (!this.sortedEvents || this.sortedEvents.length <= 6 || !direction)
        return;

      if (direction >= 0 && this.hasNext)
        this.page += 1;
      else if (direction < 0 && this.hasPrev)
        this.page -= 1;
    },
    async sortEvents() {
      const eventArray = Object.values(this.events);

      eventArray.sort((a, b) => {
        return a.startDate.getTime() < b.startDate.getTime() ? 0 : 1;
      });

      this.sortedEvents = eventArray;
      this.getEventsOnPage();
    },
    async getEventsOnPage() {
      if (this.page > this.sortedEvents.length % 6) {
        console.error("Invalid page number: " + this.page);
        this.page = 0;
        return;
      }

      const eventPage = [];
      let i;
      const len = this.sortedEvents.length;
      const offset = this.page * 6;

      for (i = 0; i < 6 && offset + i < len; i++) {
        eventPage.push(this.sortedEvents[i + offset]);
      }

      this.selectedEvents = eventPage;
    },
    async onResize() {
      const card = document.getElementById('event-card-list-container');
      const width = parseInt(window.getComputedStyle(card).getPropertyValue('width'), 10) - 30;

      if (width < 440) this.width = 220;
      if (width > 440 && width < 660) this.width = 440;
      if (width >= 660) this.width = 660;
    },
    handleEventCreated() {
      this.createEvent = false;
      this.$emit("refreshEvents")
    },
  },
  mounted() {
    if (this.events) {
      this.sortEvents();
      this.getEventsOnPage();
    }
  }
}
</script>
<style>
.event-list-title {
  width: 100%;
  padding-top: .1em;
}

.event-list-button {
  border: 1px solid #a7a7a7;
  margin: 5px 0;
}
</style>
